import { StyleSheetManager, ThemeProvider } from 'styled-components';

import { shouldForwardStyledProp } from '@/js/libs/styled-components';
import { Loader, palette } from '@/js/libs/ui';

import 'src/api';
import { Notification } from 'src/modules/Notification';
import { ThemeControllerProvider, useThemeController } from 'src/theme/ThemeController';
import { AppRouter } from './AppRouter';
import { AppSuspense } from './components/AppSuspense';
const ThemedApp = () => {
  const { themeId } = useThemeController();
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardStyledProp}>
      <ThemeProvider theme={palette[themeId]}>
        <Notification />
        <AppSuspense fallback={<Loader type='initial' />}>
          <AppRouter />
        </AppSuspense>
      </ThemeProvider>
    </StyleSheetManager>
  );
};

export const App = () => (
  <ThemeControllerProvider>
    <ThemedApp />
  </ThemeControllerProvider>
);
